import React from 'react';
const blockName = 'match-date-component';
import { t, i18n, } from '../../../jsCore/providers/i18nProvider/i18nProvider';
const MONTH_NAMES_ABBR = t('date.abbr_month_names');
export default function MatchDate({ date, }){
  const day = date.getDate();
  const monthNumber = date.getMonth() + 1;
  const monthShortName = MONTH_NAMES_ABBR[monthNumber];
  const time =  i18n.l("time.formats.hour_minute", date);
  return (
    <div className={ blockName }>
      <div className={ `${ blockName }__month-and-day-container` }>
        <div className={ `${ blockName }__month` }>
          { monthShortName }
        </div>
        <div className={ `${ blockName }__day` }>
          { day }
        </div>
      </div>
        <div className={ `${ blockName }__time` }>
          { time }
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/matchDateHomepage.js